import { render } from "./ServiceDetails3.vue?vue&type=template&id=7a945817&scoped=true"
import script from "./ServiceDetails3.vue?vue&type=script&lang=js"
export * from "./ServiceDetails3.vue?vue&type=script&lang=js"

import "./ServiceDetails3.vue?vue&type=style&index=0&id=7a945817&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a945817"]])

export default __exports__